import {
  isNil,
  filterL,
  go,
  head,
  mapL,
  rejectL,
  takeAll,
  reduce,
  each,
} from "fxjs/es";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { PROCESSING_TASK } from "./const.js";
export const _handleTouchEndOrCancel = (self, event) => {
  const rubber_band_layer_el = self._getRubberBandLayerElThrowable();
  const rubber_band = self._getRubberBandThrowable();
  const selector_controller = self._getSelectorControllerThrowable();
  const translate_transforming = self._getTranslateTransformingThrowable();
  const rotate_transforming = self._getRotateTransformingThrowable();
  const scale_transforming1 = self._getScaleTransforming1Throwable();
  const scale_transforming2 = self._getScaleTransforming2Throwable();
  if (self._touch_map.size <= 0) {
    return;
  }
  event.preventDefault();
  const { changedTouches: changed_touches, touches } = event;
  const changed_touch_map = go(
    CommonNS.UtilNS.convertTouchListToGen(changed_touches),
    mapL((touch) => [touch.identifier, touch]),
    (entries) => new Map(entries)
  );
  const touch_id_set = go(
    CommonNS.UtilNS.convertTouchListToGen(touches),
    mapL(({ identifier: id }) => id),
    (iter) => new Set(iter)
  );
  const prev_touch_map = self._touch_map;
  self._touch_map = go(
    self._touch_map.entries(),
    rejectL(([id]) => changed_touch_map.has(id)),
    rejectL(([id]) => !touch_id_set.has(id)),
    (entries) => new Map(entries)
  );
  switch (self._processing_task) {
    case PROCESSING_TASK.SELECTING: {
      if (self._selecting_touch_id == null) {
        self._processing_task = null;
        rubber_band.abortSelecting();
        return;
      }
      const touch_id = self._selecting_touch_id;
      if (self._touch_map.has(touch_id)) {
        return;
      }
      const touch = changed_touch_map.get(touch_id);
      if (touch == null) {
        self._processing_task = null;
        self._selecting_touch_id = null;
        rubber_band.abortSelecting();
        return;
      }
      const { clientX: end_client_x, clientY: end_client_y } = touch;
      const rubber_band_layer_el_ctm = rubber_band_layer_el.getCTM();
      if (rubber_band_layer_el_ctm == null) {
        throw new Error(
          `rubber_band_layer 엘리먼트의 CTM 을 구할 수 없습니다.`
        );
      }
      const rubber_band_layer_el_ctm_inverse =
        rubber_band_layer_el_ctm.inverse();
      const point = self
        ._toViewPortPoint({
          x: end_client_x,
          y: end_client_y,
        })
        .matrixTransform(rubber_band_layer_el_ctm_inverse);
      self._processing_task = null;
      self._selecting_touch_id = null;
      rubber_band.endSelecting({
        x: point.x,
        y: point.y,
      });
      return;
    }
    case PROCESSING_TASK.TRANSLATE_TRANSFORMING: {
      if (
        self._translate_transforming_touch_id != null &&
        self._touch_map.has(self._translate_transforming_touch_id)
      ) {
        return;
      }
      self._processing_task = null;
      self._translate_transforming_touch_id = null;
      translate_transforming.end();
      const els = go(
        self._els.entries(),
        filterL(([id]) => self._selected_el_ids.has(id)),
        (entries) => new Map(entries)
      );
      selector_controller.syncWith(els);
      return;
    }
    case PROCESSING_TASK.ROTATE_TRANSFORMING: {
      if (
        self._rotate_transforming_touch_id != null &&
        self._touch_map.has(self._rotate_transforming_touch_id)
      ) {
        return;
      }
      self._processing_task = null;
      self._rotate_transforming_origin_x = 0;
      self._rotate_transforming_origin_y = 0;
      self._rotate_transforming_touch_id = null;
      rotate_transforming.end();
      return;
    }
    case PROCESSING_TASK.SCALE_TRANSFORMING1: {
      if (
        self._scale_transforming1_touch_id != null &&
        self._touch_map.has(self._scale_transforming1_touch_id)
      ) {
        return;
      }
      self._processing_task = null;
      self._scale_transforming1_touch_id = null;
      scale_transforming1.end();
      return;
    }
    case PROCESSING_TASK.SCALE_TRANSFORMING2: {
      if (
        self._scale_transforming2_touch_id1 != null &&
        self._scale_transforming2_touch_id2 != null &&
        self._touch_map.has(self._scale_transforming2_touch_id1) &&
        self._touch_map.has(self._scale_transforming2_touch_id2)
      ) {
        return;
      }
      if (
        (self._scale_transforming2_touch_id1 == null ||
          !self._touch_map.has(self._scale_transforming2_touch_id1)) &&
        (self._scale_transforming2_touch_id2 == null ||
          !self._touch_map.has(self._scale_transforming2_touch_id2))
      ) {
        self._processing_task = null;
        self._scale_transforming2_touch_id1 = null;
        self._scale_transforming2_touch_id2 = null;
        scale_transforming2.end();
        return;
      }
      if (
        self._scale_transforming2_touch_id1 == null ||
        !self._touch_map.has(self._scale_transforming2_touch_id1)
      ) {
        self._scale_transforming2_touch_id1 = null;
      }
      if (
        self._scale_transforming2_touch_id2 == null ||
        !self._touch_map.has(self._scale_transforming2_touch_id2)
      ) {
        self._scale_transforming2_touch_id2 = null;
      }
      return;
    }
    case null: {
      if (self._touch_map.size <= 0) {
        const touch = go(
          changed_touch_map.values(),
          filterL((touch) => prev_touch_map.has(touch.identifier)),
          head
        );
        if (touch == null) {
          return;
        }
        const el = go(
          self._els.values(),
          filterL(({ wrapper_el }) => wrapper_el.contains(touch.target)),
          head
        );
        const old_selected_el_ids = self._selected_el_ids;
        const new_selected_el_ids = isNil(el) ? new Set() : new Set([el.id]);
        const els = go(
          new_selected_el_ids,
          mapL((id) => self._els.get(id)),
          rejectL(isNil),
          (iter) =>
            reduce(
              (els, el) => {
                els.set(el.id, el);
                return els;
              },
              new Map(),
              iter
            )
        );
        const selected_els = go(
          new_selected_el_ids,
          rejectL((id) => old_selected_el_ids.has(id)),
          mapL((id) => self._els.get(id)),
          rejectL(isNil),
          takeAll
        );
        const unselected_els = go(
          old_selected_el_ids,
          rejectL((id) => new_selected_el_ids.has(id)),
          mapL((id) => self._els.get(id)),
          rejectL(isNil),
          takeAll
        );
        const new_selected_els = go(
          new_selected_el_ids,
          mapL((id) => self._els.get(id)),
          rejectL(isNil),
          takeAll
        );
        self._selected_el_ids = new_selected_el_ids;
        selector_controller.syncWith(els);
        CommonNS.UtilNS.tryNoop(() =>
          each((el) =>
            CommonNS.UtilNS.tryNoop(() =>
              el.wrapper_el.dispatchEvent(
                new CustomEvent("@mp/sticker-editor/select", {
                  bubbles: true,
                  cancelable: true,
                  composed: false,
                  detail: {
                    el,
                    selected_els: new_selected_els,
                  },
                })
              )
            )
          )(selected_els)
        );
        CommonNS.UtilNS.tryNoop(() =>
          each((el) =>
            CommonNS.UtilNS.tryNoop(() =>
              el.wrapper_el.dispatchEvent(
                new CustomEvent("@mp/sticker-editor/unselect", {
                  bubbles: true,
                  cancelable: true,
                  composed: false,
                  detail: {
                    el,
                    selected_els: new_selected_els,
                  },
                })
              )
            )
          )(unselected_els)
        );
        return;
      }
      return;
    }
    default: {
      return;
    }
  }
};
